import { CommandData } from '../../common';

export const toggle = (trigger?: string) => {
  const message: CommandData = {
    isFromBrainfish: true,
    command: 'toggleHelpDrawer',
    trigger,
  };
  window.postMessage(message);
};
